module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cs":{"CatalogFilters":{"title":"Cena a dostupnost"}},"de":{"CatalogFilters":{"title":"Symptom"}},"sk":{"CatalogFilters":{"title":"Príznak"}}}')
  delete Component.options._Ctor
}
